import classNames from "classnames/bind";
import loadable from "@loadable/component";
import BackBtn from "images/signUp/btn_back.svg";
import {ACCOUNT} from "utils";
import {useSelector, useDispatch} from "react-redux";
import {changeSidePanel} from "store/actions/sidePanel";
import styles from "./index.module.scss";

const cn = classNames.bind(styles);

const sideIndex = [
  {
    type: ACCOUNT.SNS_LOGIN,
    component: loadable(() => import("./SignIn/components/SnsLogin")),
  },
  {
    type: ACCOUNT.TERMS_SIGN,
    component: loadable(() => import("./TermsSign")),
  },
  {
    type: ACCOUNT.ACCOUNT_CONNECT,
    component: loadable(() => import("./AccountConnect")),
  },
  {
    type: ACCOUNT.CONNECT_ANOTHER_ACCOUNT,
    component: loadable(() => import("./ConnectAnotherAccount")),
  },
  {
    type: ACCOUNT.SIGN_IN,
    component: loadable(() => import("./SignIn/components/RedbrickLogin")),
  },
  {type: ACCOUNT.FIND_PWD, component: loadable(() => import("./FindPwd"))},
  {
    type: ACCOUNT.SUCCESS_FIND,
    component: loadable(() => import("./FindId/Component/SuccessPopup")),
  },
  {
    type: ACCOUNT.SIGN_UP,
    component: loadable(() => import("./SignUp")),
  },
  {
    type: ACCOUNT.SET_NICKNAME,
    component: loadable(() => import("./SetNickname")),
  },
];

export default function AccountSidePanel({sideProps, sideType, handleSideType, playMode}) {
  const currentSidePanel = useSelector(state => state.sidePanel.type);
  const currentSide = sideIndex.find(side => side.type === currentSidePanel);
  const dispatch = useDispatch();
  const returnPanelType =
    currentSidePanel === ACCOUNT.FIND_ID ||
    currentSidePanel === ACCOUNT.FIND_PWD ||
    currentSidePanel === ACCOUNT.SUCCESS_FIND ||
    currentSidePanel === ACCOUNT.SET_NICKNAME ||
    currentSidePanel === ACCOUNT.SIGN_UP
      ? ACCOUNT.SIGN_IN
      : ACCOUNT.SNS_LOGIN;
  return (
    <div className={cn("container")}>
      {currentSidePanel !== ACCOUNT.SNS_LOGIN && (
        <button className={cn("back")} type="button" onClick={() => dispatch(changeSidePanel({type: returnPanelType}))}>
          <img src={BackBtn} alt="go back" />
        </button>
      )}
      {currentSide && currentSide.component ? (
        <currentSide.component sideProps={sideProps} sideType={sideType} handleSideType={handleSideType} playMode={playMode} />
      ) : null}
    </div>
  );
}
